import config from "../helpers/config.js";
import { cst } from "../helpers/cst.js";
import $ from "jquery";

export class Controller {
  constructor(self) {
    this.self = self;
  }

  logActivity() {
    $.ajax({
      async: true,
      type: "post",
      url: "api/log-activity.php",
      headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
      data: {
        device: window.navigator.userAgent,
      },
      dataType: "JSON",
    });
  }

  loadQuestions() {
    let self = this.self;
    const dataSource = config.online
      ? "api/get-questions.php"
      : "question.json";
    $.ajax({
      async: false,
      type: "get",
      url: dataSource,
      headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
      dataType: "JSON",
      success(data) {
        self.allQuestions = data;
      },
    }).responseJSON;

    if (config.numberCategories >= 2) {
      this.filterQuestions(self.allQuestions);
    } else {
      if (config.randomizedQuestions) this.shuffleQuestions();
      this.nextQuestion();
    }
  }

  filterQuestions(allQuestions) {
    this.self.filteredQuestions = [];

    this.self.categories.forEach((name) => {
      this.self.filteredQuestions[name] = allQuestions.filter(
        function (question) {
          return question.category === name;
        },
      );
    });

    this.nextQuestionCategories();
  }

  // -> => != !==
  nextQuestionCategories() {
    const areAllArraysEmpty = Object.values(this.self.filteredQuestions).every(
      (array) => {
        return Array.isArray(array) && array.length === 0;
      },
    );

    if (areAllArraysEmpty) {
      this.self.end = true;
      // TODO: Trigger end of the game
    } else {
      let keys = Object.keys(this.self.filteredQuestions);
      const array =
        this.self.filteredQuestions[keys[(keys.length * Math.random()) << 0]];

      if (array.length > 0) {
        this.self.question = array[0];
        array.shift();
      } else {
        this.nextQuestionCategories();
      }
    }
  }

  nextQuestion() {
    this.self.question = this.self.allQuestions[0];
    this.self.allQuestions.shift();
  }

  shuffleQuestions() {
    for (let i = this.self.allQuestions.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.self.allQuestions[i], this.self.allQuestions[j]] = [
        this.self.allQuestions[j],
        this.self.allQuestions[i],
      ];
    }
  }

  rollDice() {
    this.self.sndRoll.play();
    this.self.boxDice.setVisible(true);
    this.self.dice.setVisible(true);
    this.self.dice.play("sprite-dice-roll");
    this.self.btnRoll.disableInteractive();
    this.self.btnRoll.setTexture("btn-roll-bw");
    this.self.btnRules.disableInteractive();
    this.self.btnPause.disableInteractive();

    setTimeout(() => {
      this.findNextPosition();
    }, 1500);
  }

  findNextPosition() {
    let min = Math.ceil(1);
    let max = Math.floor(6);
    const rndNum = Math.floor(Math.random() * (max - min + 1)) + min;

    this.self.dice.setTexture("sprite-dice", rndNum - 1);

    let nextPosition = this.self.player.position + rndNum;
    const timeout = nextPosition - this.self.player.position;

    if (nextPosition >= 99) {
      nextPosition = 99;
      this.self.end = true;
    }

    setTimeout(() => {
      this.self.dice.setVisible(false);
      this.self.boxDice.setVisible(false);
      this.moveToPosition(nextPosition, timeout);
    }, 1500);
  }

  moveToPosition(nextPosition, timeout) {
    let count = -1;

    for (let i = this.self.player.position + 1; i <= nextPosition; i++) {
      count++;
      this.animatePawn(count, i);
    }

    setTimeout(() => {
      this.checkSquare();
    }, timeout * 400);

    this.self.player.position = nextPosition;
  }

  animatePawn(count, i) {
    setTimeout(() => {
      this.self.tweens.add({
        targets: this.self.player.pawn,
        x: {
          value: this.self.squares[i].position.x,
          duration: 400,
        },
        y: {
          value: this.self.squares[i].position.y,
          duration: 400,
        },
        onStart: () => {
          if (
            this.self.squares[i].position.y ===
            this.self.squares[i - 1].position.y
          ) {
            this.self.tweens.add({
              targets: this.self.player.pawn,
              y: {
                value: "-=25",
                duration: 200,
                yoyo: true,
              },
            });
          }
        },
      });

      this.self.sndPawn.play();
    }, count * 400);
  }

  movementSquareNewPosition(position) {
    setTimeout(() => {
      this.self.tweens.add({
        targets: this.self.player.pawn,
        x: {
          value: this.self.squares[position].position.x,
          duration: 300,
        },
        y: {
          value: this.self.squares[position].position.y,
          duration: 300,
        },
      });
      this.self.player.position = position;
      this.checkSquare();
      this.self.sndPawn.play();
    }, 400);
  }

  checkSquare() {
    if (!this.self.end) {
      switch (this.self.squares[this.self.player.position].type) {
        case "movement":
          this.movementSquareNewPosition(
            this.self.squares[this.self.player.position].squareIndex,
          );
          break;
        case "magic-x2":
          this.showQuestion(2);
          break;
        case "magic-x3":
          this.showQuestion(3);
          break;
        default:
          this.showQuestion(1);
          break;
      }
    } else {
      this.fireworks(true);
    }
  }

  showQuestion(points) {
    let self = this.self;
    let self2 = this;
    setTimeout(function () {
      self.scene.pause();
      self.scene.launch(cst.scenes.questions, {
        question: self.question,
        points: points,
      });

      if (config.numberCategories >= 2) {
        self2.nextQuestionCategories();
      } else {
        self2.nextQuestion();
      }
    }, 1000);
  }

  fireworks(finished) {
    let self = this;
    let count = 0;
    this.self.sndCongratulations.play();

    this.self.anims.create({
      key: "anim-firework-blue",
      frames: this.self.anims.generateFrameNames("sprite-firework-blue"),
      frameRate: 30,
      repeat: 0,
    });

    this.self.anims.create({
      key: "anim-firework-yellow",
      frames: this.self.anims.generateFrameNames("sprite-firework-yellow"),
      frameRate: 30,
      repeat: 0,
    });

    (function loop(times) {
      setTimeout(
        () => {
          const firework = self.self.add
            .sprite(
              getRandomNumber(150, 650),
              getRandomNumber(150, 950),
              "sprite-firework-blue",
            )
            .play("anim-firework-blue");

          firework.on("animationcomplete", () => {
            firework.destroy();
            count++;
            if (count === 10) self.showEndBox(finished);
          });

          console.log(times);
          if (--times) loop(times); //  decrement i and call myLoop again if i > 0
        },
        getRandomNumber(500, 1000),
      );
    })(5);

    (function loop(times) {
      setTimeout(
        () => {
          const firework = self.self.add
            .sprite(
              getRandomNumber(150, 650),
              getRandomNumber(150, 950),
              "sprite-firework-yellow",
            )
            .play("anim-firework-yellow");

          firework.on("animationcomplete", () => {
            firework.destroy();
            count++;
            if (count === 10) self.showEndBox(finished);
          });

          console.log(times);
          if (--times) loop(times); //  decrement i and call myLoop again if i > 0
        },
        getRandomNumber(500, 1000),
      );
    })(5);
  }

  showEndBox(finished) {
    let self = this.self;
    this.self.events.off("resume");
    const key = finished ? "box-congratulations" : "box-no-more-questions";
    this.self.add.image(
      this.self.cameras.main.width / 2,
      this.self.cameras.main.height / 2,
      key,
    );

    if (config.numberCategories >= 2) {
      setTimeout(() => {
        self.scene.start(cst.scenes.endCategories, {
          scene: cst.scenes.board,
          score: self.player.score,
          log: self.categoriesLog,
        });
      }, 3000);
    } else {
      setTimeout(() => {
        self.scene.start(cst.scenes.end, {
          scene: cst.scenes.board,
          score: self.player.score,
        });
      }, 3000);
    }
  }
}

const getRandomNumber = (min, max) => Math.random() * (max - min) + min;
